import React from "react";
import "../../styles/Introduction.css";

function Introduction() {
  return (
    <div className="Introduction">
      <div className="PhotoIntro">
        <img src="photo_LucasG.jpg" alt="Lucas G" />
      </div>
      <div className="TextZoneIntro">
        <h2>My name is Lucas, I'm an Analyst in Cyber Security, working in Detection Engineering.</h2>

        <div className="CertSection">
          <img src="secplus.png" alt="CompTIA Security+" className="cert-logo" />
          <p>
            I hold a CompTIA Security+ certification and actively participate in CTF competitions and hackathons to sharpen my skills. I am currently specializing in cloud security, with a focus on threat detection and incident response.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Introduction;
